import { AnswerType, ICategory } from "../models";

export const round97: ICategory[] = [
	{
		id: "1qxjiv9k1sca3q6",
		name: "Dungeons and Dragons",
		answers: [
			{
				id: "1qxjiv9k1sca3qb",
				type: AnswerType.TEXT,
				answer: "This game mechanic dictates whom makes the first move in a combat scenario.",
				question: 'What is "Initiative"?',
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qg",
				type: AnswerType.TEXT,
				answer:
					"This player class first debuted in 2004 as an alternative to the edition’s core magic classes, but has since been included as a core class itself in both 4th and 5th editions ",
				question: "What is the Warlock?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3ql",
				type: AnswerType.TEXT,
				answer:
					"These monsters are typically subdivided into “chromatic” and “metallic” versions, but other variants have been widely published. ",
				question: "What are dragons?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qq",
				type: AnswerType.TEXT,
				answer:
					"Casting this iconic spell requires a tiny amount of excrement from a nocturnal flying mammal. ",
				question: "What is Fireball?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qv",
				type: AnswerType.TEXT,
				answer:
					"This author won Wizards of the Coast’s Fantasy Setting Search in 2002, bringing his Eberron campaign setting to D&D players around the world. ",
				question: "Who is Keith Baker?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjiv9k1sca3q7",
		name: "Disney Films",
		answers: [
			{
				id: "1qxjiv9k1sca3qc",
				type: AnswerType.TEXT,
				answer:
					"This animated film, based on a book of the same name by Rudyard Kipling, was the last Walt Disney produced before his death in 1966. ",
				question: "What is The Jungle Book?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qh",
				type: AnswerType.TEXT,
				answer:
					"This song, which was the third duet sung by a Disney Prince and Princess, was also the only Disney song to win a Grammy award for Song of the Year. ",
				question: 'What is "A Whole New World"?',
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qm",
				type: AnswerType.TEXT,
				answer:
					"Tony Jay supplied the voice for this character, the villain of an animated film set in historic Paris. ",
				question: "Who is Judge Claude Frollo?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qr",
				type: AnswerType.TEXT,
				answer:
					"This 1940 animated film was released in only 14 theaters worldwide, due to its complicated sound system designed to simulate a live symphony orchestra. ",
				question: "What is Fantasia?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qw",
				type: AnswerType.TEXT,
				answer:
					"Walt Disney originally considered producing this full-length animated feature as a live action film with Mary Martin playing the lead role. ",
				question: "What is Peter Pan?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjiv9k1sca3q8",
		name: "Lord of the Rings",
		answers: [
			{
				id: "1qxjiv9k1sca3qd",
				type: AnswerType.TEXT,
				answer:
					"This character started the series under a different color designation, but finishes the series as “the White.” ",
				question: "Who is Gandalf?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qi",
				type: AnswerType.TEXT,
				answer:
					'This "hobbit-y" director brought the Lord of the Rings trilogy into the new millennium with an award-winning series of films based on these novels. ',
				question: "Who is Peter Jackson?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qn",
				type: AnswerType.TEXT,
				answer:
					"This prequel to the Lord of the Rings trilogy includes the story of the creation of Ea, the fictional setting for these books. ",
				question: "What is The Silmarillion?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qs",
				type: AnswerType.TEXT,
				answer:
					"This ring of power was wielded by Galadriel, and lent it’s preservative powers to her domain, Lorien. ",
				question: "What is Nenya?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qx",
				type: AnswerType.TEXT,
				answer:
					"With it’s counterpart Quenya, Tolkien invented this language, spoken by the “Gray Elves” of Middle-Earth. ",
				question: "What is Sindarin?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjiv9k1sca3q9",
		name: "Harry Potter",
		answers: [
			{
				id: "1qxjiv9k1sca3qe",
				type: AnswerType.TEXT,
				answer:
					"This magical location in London is the first place Harry and Hagrid go to while retrieving Harry’s school supplies in Harry Potter and the Philosopher’s Stone. ",
				question: "What is the Leaky Cauldron?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qj",
				type: AnswerType.TEXT,
				answer:
					"This character, who shares a dorm room with Hermione Granger and Lavender Brown, has a twin sister in a different Hogwarts house. ",
				question: "Who is Pavarti Patil?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qo",
				type: AnswerType.TEXT,
				answer:
					"Nosebleed Nougat and Fever Fudge are two varieties of this joke-store product invented and produced by the Weasley twins. ",
				question: "What are Skiving Snackboxes?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qt",
				type: AnswerType.TEXT,
				answer:
					"This incantation can be used to magically lock a door, and prevents it being unlocked by non-magical methods. ",
				question: "What is Colloportus?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qy",
				type: AnswerType.TEXT,
				answer: "Albus Dumbledore enjoys this sport, according to his Chocolate Frog Card. ",
				question: "What is Ten-pin Bowling?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjiv9k1sca3qa",
		name: "Marvel Cinematic Universe",
		answers: [
			{
				id: "1qxjiv9k1sca3qf",
				type: AnswerType.TEXT,
				answer:
					" This main character of the feature film Black Panther is the king of the fictional nation of Wakanda. ",
				question: "Who is T'Challa?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qk",
				type: AnswerType.TEXT,
				answer:
					"The All-Seeing Asgardian Heimdall stands over this multicolored interdimensional bridge. ",
				question: "What is Bifrost?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qp",
				type: AnswerType.TEXT,
				answer:
					"While many Marvel superhero-themed movies were produced prior, this move debuted the current “Marvel Cinematic Universe” shared media universe of Marvel intellectual properties with a cohesive story arc in 2008. ",
				question: "What is Ironman?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qu",
				type: AnswerType.TEXT,
				answer:
					"In the 2017 movie Thor: Ragnarok, the character Hela (played by Cate Blanchett) is a child of this recurrent character. ",
				question: "Who is Odin?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qz",
				type: AnswerType.TEXT,
				answer:
					"One of the “Infinity Stones” was introduced as a time-bending magical artifact in 2016’s Dr. Strange under this eponymous moniker. ",
				question: "What is the Eye of Agamotto?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	}
];
